module.exports = __webpack_public_path__ + "static/img/trpart1.fb0068c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trpart1.png
// module id = Caof
// module chunks = 9